import { PartDetector } from "../partdetection_new/PartDetector";
import { Guidance } from "../guidance_new/GuidanceMain";
import { regionAndPartsVerification } from "../guidance_new/ImgFeedback";
import { loadCarPartModel } from "../partdetection_new/NewPartDetector";

let imgQualityFactor = 0.8;
let kotakVehicleDataFlag = false;
let kotakVehicleData = {};
let kiwiValidationCheck = [];
let resumeTimestampFlag = false;
let resumeTimeStamoSecondFlag = false;
let resumeTimeStamoSecondFlagCount = true;
let resumeTimeStampFlagOneTime = true;
let odometer = 0;
let inputMetaData = {};
let kiwiValidationAgentFlow = true;
let inputMetaDataFlag = false;
let imageSize = 0;
let redirectVideoToImgFlag = true;
let iosDevice = false;
let webpFormatSupport = true;
let color = "NA";
let documentTagIndex = "";
let imageEnhancement = false;
let checkResImgFBUpldImgFlg = true;
let totalImagesQueue = 0;
let internetLatency = "";
let globalImageQueue = [];
let imageQueue = [];
let backupImages = [];
let imageSending = false;
let imageSending2 = false;
let imageSending3 = false;
let wondleCount = 0;
let count = 0;
let interval = null;
let interval2 = null;
let token = "";
let userEmail = "";
let location = { latitude: 0, longitude: 0 };
let inspectionId = "";
let retake = 0;
let abourt = true;
let rejectedImages = 0;
let OnceUpload = true;
let processCompleted = false;
let logBugs = true;
let imginterval;
let totalVideos = 0;
let subCompleted = false;
let subMandatoryCompleted = false;
let vmgFlowType = null;
let vmgUrl = null;
let authorization = null;
let customHiibVmg = false;
let stopResizing = [false];
let setLoggingstatus = "true";
let insId = "";
let nisanCustomerEmailId = "";
let kotakRecaptureCase = false;
let oldInspectionId = "";
let videoFlag = true;
let angleFlag = false;
let feedbackTimer = 15000;
let ackoAnyGreyFlag = true;
let vinFeedback = true;

let resumeFlowAllow = false;
let condition = {};
let mandatory = {};
let subMandatory = {};
let subCondition = {};
let subConditionSub = {};
let subMandatorySub = {};
let damageCount = 0;
let windshieldDamageCount = 0;
let redisFlowSetFirstTime = false;
let labels;
let modalResult = null;
let lambdaResult = null;
let cameraOpenFlag = false;

let partDetector = new PartDetector();
let modelPromise = {};
let modelReHitCount = 0;
let pathData = [];
let userLog = {};
let totalImageFeedbackMssgResume = {};
let totalImageForAnalysisResume = [];
let totalImageForAnalysisResumeByMe = [];
let imageFeedbackStatusNBtn = ["", false];
let imageFeedbackCount = 0;
let feedbackCountResume = 0;
let totalImageFeedbackMssg = {};
let kotakRecapMenuSection = [];
let kotakRecapSubSection = {};
let aspectRatioClientList = [
  "client_1367",
  "client_1367_prod",
  "client_1409",
  "prod_testing",
  "client_1326",
  "client_1326_prod",
  "client_1505",
  "client_1505_prod",
  "client_876",
  "liberty_dev",
];
let clientID = "";
let personaId;
let feedbackFlag = false;
let countDownTimer = 15;
let checkSectionAllowFlag = true;
let captureFlag;
let guidance;
let redyForUpload = false;
let checkFormupload;
let hyundaiData = {};
let imageHyundaiAnalysis = [];
let storeCompleteTag = [];
let allSideCoveredVideo = false;
let portoModuleComplete = [];
let portoModuleList = [];
let hyudaiVinDisable = "";
let kiwi360TagList = {
  "Front_interim": 0,
  "Front-Isometric-Right_interim": 0,
  "Side-Right_interim": 0,
  "Rear-Isometric-Right_interim": 0,
  "Rear_interim": 0,
  "Rear-Isometric-Left_interim": 0,
  "Side-Left_interim": 0,
  "Front-Isometric-Left_interim": 0
}
let greenOrRedRestrictionClientList = [
  "client_1514",
  "client_1630",
  "client_1630_dev",
  "client_1630_prod",
  "client_1630_uat",
  "client_1630_stagging",
  "client_1514_uat",
  "client_1525",
  "client_1452",
  "client_1403_uat",
  "client_1403_dev",
  "client_1319",
  "client_1293",
  "client_898",
  "client_1403_prod",
  "clientopt.01.1",
  "clientopt.02.1",
  "clientiopt.03.1",
  "clientiopt.04.1",
  "clientiopt.05.1",
  "clientiopt.06.1",
  "clientiopt.07.1",
  "clientiopt.08.1",
  "porto_seguros",
  "porto_seguros_uat",
  "hc_pilot",
  "arval_dev",
  "arval_prod",
];

export const setportoModuleList = (d) => {
  portoModuleList.push(d);
};

export const getGreenOrRedRestrictionClientList = () => {
  return greenOrRedRestrictionClientList;
};

export const getKiwiValidationCustomerFlow = () => {
  return kiwiValidationAgentFlow;
};

export const getResumeTimestampFlag = () => {
  return resumeTimestampFlag;
};

export const getOdometer = () => {
  return odometer;
};

export const getImgQualityFactor = () => {
  return imgQualityFactor;
};

export const getKiwiValidationCheck = () => {
  return kiwiValidationCheck;
};

export const getRedirectVideoToImgFlag = () => {
  return redirectVideoToImgFlag;
};

export const sethyudaiVinDisable = (d) => {
  hyudaiVinDisable = d;
};

export const getWebpImageFormat = () => {
  return webpFormatSupport;
};

export const getColor = () => {
  return color;
};

export const setPortoModuleComplete = (d) => {
  portoModuleComplete.push(d);
};
export const setAllSideCoveredVideo = (d) => {
  allSideCoveredVideo = d;
};

export const getDocumentTagIndex = () => {
  return documentTagIndex;
};

export const getImageQueueLength = () => {
  return imageQueue.length;
};

export const getImageEnhancement = () => {
  return imageEnhancement;
};

export const getVinFeedback = () => {
  return vinFeedback;
};

export const getstoreCompleteTag = () => {
  return storeCompleteTag;
};

export const setstoreCompleteTag = (d) => {
  storeCompleteTag.push(d);
};

export const getimageHyundaiAnalysis = () => {
  return imageHyundaiAnalysis;
};

export const setimageHyundaiAnalysis = (d) => {
  if (d === "empty") {
    imageHyundaiAnalysis = [];
  } else {
    imageHyundaiAnalysis.push(d);
  }
};

export const getImageList = () => {
  return globalImageQueue;
};

export const setHyundaiData = (d) => {
  hyundaiData = d;
};

export const setGuidance = (config, clientId) => {
  guidance = new Guidance(
    config["video-page"]["guidanceMessages"],
    clientId,
    config,
  );
};

export const getFeedbackTimer = () => {
  return feedbackTimer;
};
export const getAckoAnyGreyFlag = () => {
  return ackoAnyGreyFlag;
};

export const getModalResult = () => {
  return modalResult;
};

export const getCameraOpenFlag = () => {
  return cameraOpenFlag;
};

export const getLambdaResult = () => {
  return lambdaResult;
};

export const setResumeTimeStamoSecondFlag = (flag) =>
  (resumeTimeStamoSecondFlag = flag);
export const setKotakVehicleDataFlag = (flag) => (kotakVehicleDataFlag = flag);
export const setKotakVehicleData = (vehicleData) =>
  (kotakVehicleData = vehicleData);
export const setResumeTimestampFlag = (flag) => (resumeTimestampFlag = flag);
export const setOdometer = (reading) => (odometer = reading);
export const setRedirectVideoToImgFlag = (flag) =>
  (redirectVideoToImgFlag = flag);
export const setImgQualityFactor = (factor) => (imgQualityFactor = factor);
export const setKiwiValidationCheckData = (element) =>
  kiwiValidationCheck.push(element);
export const setinputMetaData = (data) => (inputMetaData = data);
export const setinputMetaDataFlag = (flag) => (inputMetaDataFlag = flag);
export const setIsIosDevice = (flag) => (iosDevice = flag);
export const setWebpImageFormat = (flag) => (webpFormatSupport = flag);
export const setDocumentTagIndex = (index) => (documentTagIndex = index);
export const setImageEnhancement = (flag) => (imageEnhancement = flag);
export const setColor = (c) => (color = c);
export const setFeebackTimer = (time) => (feedbackTimer = time);
export const setAckoAnyGreyFlag = (flag) => (ackoAnyGreyFlag = flag);
export const setCameraOpenFlag = (flag) => (cameraOpenFlag = flag);
export const setLambdaResult = (result) => (lambdaResult = result);
export const setModalResult = (result) => (modalResult = result);
export const setKiwiValidationCustomerFlow = (flag) => (kiwiValidationAgentFlow = flag);

export const getGuidance = () => {
  return guidance;
};

export const getGlobalImageQueue = () => {
  return globalImageQueue;
};

export const setGlobalImageQueue = (image) => {
  globalImageQueue = globalImageQueue.filter((item) => item.tag !== image.tag);
  globalImageQueue.push(image);
};

const removeGlobalImageQueue = (tag) => {
  globalImageQueue = globalImageQueue.filter((item) => item.tag !== tag);
};

export const getInternetLatency = () => {
  return internetLatency;
};

export const setInternetLatency = (latency) => {
  internetLatency = latency;
};

export const getPartDetector = () => {
  return partDetector;
};

export const setAngleFlag = (flag) => (angleFlag = flag);
export const setCaptureFlag = (flag) => (captureFlag = flag);
export const getCaptureFlag = () => {
  return captureFlag;
};

export const imageVerficationModal = async (
  region,
  currentTag,
  detectionTemp,
  angle,
) => {
  let result = await regionAndPartsVerification(
    region.find((item) => item[currentTag] !== undefined)?.[currentTag],
    detectionTemp,
    angle,
  );
  modalResult = result;
};

export const blurLumaLambda = (image, inspectionId, clientId) => {
  imageFeedbackLambda({
    inspection_id: inspectionId,
    image:
      getWebpImageFormat() && !iosDevice
        ? image.replace(/^data:image\/webp;base64,/, "")
        : image.replace(/^data:image\/jpeg;base64,/, ""),
    client_id: clientId,
    new_image_app: true,
    region: "eu-central-1",
    env: 1,
    tag: "testing",
    type: "car",
    webpFormat: getWebpImageFormat(),
  }).then((res) => {
    lambdaResult = res;
  });
};

export const getConstraint = (config, clientId) => {
  let constraints;
  let ios = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
  if (aspectRatioClientList.includes(clientId)) {
    if (ios) {
      constraints = {
        video: {
          width: { ideal: 1920 },
          height: { ideal: 1080 },
          facingMode: "environment",
          aspectRatio: { ideal: 4 / 3 },
          zoom: {
            ideal: Object.keys(config).includes("zoom")
              ? config["zoom"]
                ? 0.5
                : 1
              : 0.5,
          },
        },
        audio: false,
      };
    } else {
      constraints = {
        video: {
          width: { ideal: 1920 },
          height: { ideal: 1080 },
          facingMode: "environment",
          aspectRatio: ["client_1367", "client_1367_prod"].includes(clientId)
            ? { ideal: 4 / 3 }
            : { ideal: 16 / 9 },
          zoom: {
            ideal: Object.keys(config).includes("zoom")
              ? config["zoom"]
                ? 0.5
                : 1
              : 0.5,
          },
        },
        audio: false,
      };
    }
    return constraints;
  } else if (
    Object.keys(config).includes("aspectRatio") &&
    config["aspectRatio"]
  ) {
    constraints = {
      video: {
        width: 1920,
        height: 1080,
        facingMode: "environment",
        aspectRatio: ios ? { ideal: 4 / 3 } : { ideal: 16 / 9 },
        zoom: {
          ideal: Object.keys(config).includes("zoom")
            ? config["zoom"]
              ? 0.5
              : 1
            : 0.5,
        },
      },
      audio: false,
    };
    return constraints;
  } else {
    constraints = {
      video: {
        width: 1920,
        height: 1080,
        facingMode: "environment",
        zoom: {
          ideal: Object.keys(config).includes("zoom")
            ? config["zoom"]
              ? 0.5
              : 1
            : 0.5,
        },
      },
      audio: false,
    };
    return constraints;
  }
};

export const getAspectRatioClientList = (clientId, config) => {
  return (
    aspectRatioClientList.includes(clientId) ||
    (Object.keys(config).includes("aspectRatio") && config["aspectRatio"])
  );
};

export const translateText = async (text, languageCode) => {
  // let translatedLanguage = text;
  // try {
  //   const response = await fetch(
  //     `https://translation.googleapis.com/language/translate/v2?key=${process.env.API_KEY_TRANSLATE}`,
  //     {
  //       method: "POST",
  //       headers: {
  //         "Content-Type": "application/json",
  //       },
  //       body: JSON.stringify({
  //         q: text,
  //         source: "en",
  //         target: languageCode,
  //       }),
  //     }
  //   );

  //   const data = await response.json();
  //   translatedLanguage = data.data.translations[0].translatedText
  //     ? data.data.translations[0].translatedText
  //     : text;
  // } catch (error) {
  //   console.log("Error translating text:", error.message);
  // }
  return text;
};

export const startModelInt8 = (app) => {
  modelPromise = loadCarPartModel();
};

export const startModel = (app) => {
  // try {
  modelPromise = partDetector.loadModelFromURL(app);
  // } catch (e) {
  //   if (modelReHitCount < 4) {
  //     startModel();
  //   }
  //   modelReHitCount = modelReHitCount + 1;
  // }
};

export const getModel = () => {
  return modelPromise;
};

let feedbackValue = "";
export const setLogging = (v) => (setLoggingstatus = v);
export const setFeedBackStatus = (v) => (feedbackValue = v);
export const feedBackStatus = () => {
  return feedbackValue;
};
export const setInspectionID = (ins) => {
  insId = ins;
};
export const getInspectionID = () => {
  return insId;
};
export const getCountDownTimer = () => {
  return countDownTimer;
};
export const getImgFeedbackFlag = () => {
  return feedbackFlag;
};
export const setClientIdUtils = (id) => {
  clientID = id;
};
export const getUserLog = () => {
  return userLog;
};
export const getSubMandatoryCompleted = () => {
  return subMandatoryCompleted;
};
export const getTotalImageFeedbackMssg = () => {
  return totalImageFeedbackMssg;
};
export const getSubCompleted = () => {
  return subCompleted;
};
export const getPersonaId = () => {
  return personaId;
};
export const getVideoFlag = () => {
  return videoFlag;
};
export const getAnglFlag = () => {
  return angleFlag;
};
export const getDectectLabels = () => {
  return labels;
};
export const getCheckSectionAllowFlag = () => {
  return checkSectionAllowFlag;
};
export const setDectectedLabels = (data) => (labels = data);
export const setKotakRecapSubSection = (mainBlock, subBlock) => {
  if (
    Object.keys(kotakRecapSubSection).length === 0 ||
    !Object.keys(kotakRecapSubSection).includes(mainBlock)
  ) {
    let list = [subBlock];
    kotakRecapSubSection[mainBlock] = list;
  } else {
    let list = kotakRecapSubSection[mainBlock];
    list.push(subBlock);
    kotakRecapSubSection[mainBlock] = list;
  }
};
export const setKotakRecapMenuSection = (section) =>
  kotakRecapMenuSection.push(section);
export const setPersonaId = (id) => (personaId = id);
export const setCountDownTimer = (timer) => (countDownTimer = timer);
export const setImgFeedbackFlag = (flag) => (feedbackFlag = flag);
export const setCheckSectionAllowFlag = (flag) =>
  (checkSectionAllowFlag = flag);
export const setKotakRecaptureCase = (flag) => (kotakRecaptureCase = flag);
export const setKotakOldInsp = (id) => (oldInspectionId = id);
export const setSubCompleted = (flag) => (subCompleted = flag);
export const setTotalImageFeedbackMssg = (value) =>
  (totalImageFeedbackMssg = value);
export const setSubMandatoryCompleted = (flag) =>
  (subMandatoryCompleted = flag);
export const setUserLogs = async (log) => (userLog = log);
export const setVideoFlag = (flag) => (videoFlag = flag);
export const initializeToken = (tk) => (token = tk);
export const setPathData = (data) => (pathData = data);
export const initializeEmail = (email) => (userEmail = email);
export const initializeLocation = (loc) => (location = loc);
export const initializeInspectionId = (id) => (inspectionId = id);
export const initializeretake = (rtk) => (retake = rtk);
export const setVmgFlowType = (data) => (vmgFlowType = data);
export const setVmgUrl = (data) => (vmgUrl = data);
export const setAuthorization = (data) => (authorization = data);
export const setCustomHiibVmg = (data) => (customHiibVmg = data);
export const setResizing = (data) => (stopResizing = data);
export const setConditionResume = (data) => (condition = data);
export const setMandatoryResume = (data) => (mandatory = data);
export const setSubMandatoryResume = (data) => (subMandatory = data);
export const setSubMandatorySubResume = (data) => (subMandatorySub = data);
export const setSubConditionResume = (data) => (subCondition = data);
export const setSubConditionSubResume = (data) => (subConditionSub = data);
export const setResumeFlowAllow = (data) => (resumeFlowAllow = data);
export const setImgFeedbackCount = (data) => (imageFeedbackCount = data);
export const setFeedbackCountResume = (data) => (feedbackCountResume = data);
export const setTotalImageFeedbackMssgResume = (data) =>
  (totalImageFeedbackMssgResume = data);
export const setTotalImageForAnalysisResumeByMe = (data) =>
  (totalImageForAnalysisResumeByMe = data);
export const setTotalImageForAnalysisResume = (data) =>
  (totalImageForAnalysisResume = data);
export const setImageFeedbackStatusNBtn = (data) =>
  (imageFeedbackStatusNBtn = data);
export const setDamageCount = (data) => (damageCount = data);
export const getKotakRecapSubSection = (current, sub) => {
  if (Object.keys(kotakRecapSubSection).includes(current)) {
    if (kotakRecapSubSection[current].includes(sub)) return true;
    else return false;
  } else return false;
};
export const getKotakRecapMenuSection = () => {
  return kotakRecapMenuSection;
};
export const getFeedbackCountResume = () => {
  return feedbackCountResume;
};
export const getKotakRecaptureCase = () => {
  return kotakRecaptureCase;
};
export const getKotakOldInsp = () => {
  return oldInspectionId;
};
export const getImgFeedbackCount = () => {
  return imageFeedbackCount;
};
export const getImageFeedbackStatusNBtn = () => {
  return imageFeedbackStatusNBtn;
};
export const getTotalImageForAnalysisResumeByMe = () => {
  return totalImageForAnalysisResumeByMe;
};
export const getTotalImageForAnalysisResume = () => {
  return totalImageForAnalysisResume;
};
export const getTotalImageFeedbackMssgResume = () => {
  return totalImageFeedbackMssgResume;
};
export const setWondleCount = () => {
  wondleCount = ++wondleCount;
};
export const getWondleCount = () => {
  return wondleCount;
};
export const getDamageCount = () => {
  return damageCount;
};
export const setWindShieldDamageCount = (data) =>
  (windshieldDamageCount = data);
export const getWindshieldModuleCount = () => {
  return windshieldDamageCount;
};
export const setRedisFlowSetFirstTime = (flag) =>
  (redisFlowSetFirstTime = flag);
export const setResumeFlowCount = (data) => (count = data);

export const makeRequest = async (URL, DATA, flag) => {
  if (flag) {
    const res = await fetch(URL, {
      method: "POST",
      body: DATA,
    });
    return res;
  } else {
    const res = await fetch(URL, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      // signal: abortController,
      body: JSON.stringify(DATA),
    });
    return res;
  }
};

export const setAckoCompletionRedisTag = async () => {
  try {
    await makeRequest(
      `/setAckoCompletionRedisTag/${inspectionId ? inspectionId : insId}`,
    );
  } catch (err) {
    console.log(
      "faces error while setting acko redis 85%+ completion tag : ",
      err,
    );
  }
};

export const setNewCompleteRedisTag = async () => {
  try {
    await makeRequest(
      `/setNewCompleteRedisTag/${inspectionId ? inspectionId : insId}`,
    );
  } catch (err) {
    console.log("faces error while setting new complete redis tag : ", err);
  }
};

export const sendRakutenCallback = async (inspectionId, token) => {
  try {
    await makeRequest(`/rakutenCallback`, {
      inspectionId: inspectionId,
      token: token,
    });
  } catch (err) {
    console.log("faces error while sending callback to Rakuten : ", err);
  }
};

export const setResumeFlowEmail = async (inspectionId, email) => {
  try {
    if (inspectionId) {
      await makeRequest(`/setResumeFlowEmail/${inspectionId}/SET`, {
        data: email,
      });
    }
  } catch (err) {
    console.log("some error occur whikle saving email  ::::::  ", err);
  }
};

export const isAllImgUploaded = async (inspectionId) => {
  let makeReqForAnalysis = await makeRequest(
    `/fetchResumeTotImgAnalysis/${inspectionId}/GET`,
  );
  if (makeReqForAnalysis.ok && makeReqForAnalysis.status === 200) {
    const totImgAnalysis = await makeReqForAnalysis.json();
    if (totImgAnalysis && totImgAnalysis.length >= 8) {
      setTotalImageForAnalysisResume(totImgAnalysis);
      return true;
    }
  }
  return false;
};

const setImageFeedbackMsg = async (tag) => {
  delete totalImageFeedbackMssgResume[tag];
  totalImageForAnalysisResume = totalImageForAnalysisResume.filter(
    (item) => item["currentTag"] !== tag,
  );
  makeRequest(`/fetchResumeImageFeedbackMsg/${inspectionId}/SET`, {
    body: totalImageFeedbackMssgResume,
  });
  makeRequest(
    `/fetchResumeTotImgAnalysis/${inspectionId}/SET`,
    totalImageForAnalysisResume,
  );
  //storing 360 tag which got uploaded successfully in redis
  makeRequest(`/fetchResumeImgFeedbackTag/${inspectionId}/SET`, {
    tagName: tag,
  });
};

const setImageFeedbackMsgNImages = async (inspectionId, image, tag) => {
  try {
    if (inspectionId) {
      if (totalImageForAnalysisResume.length === 0) {
        makeRequest(`/fetchResumeImagefeedbackStatus/${inspectionId}/SET`, {
          data: imageFeedbackStatusNBtn,
        });
      }
      totalImageForAnalysisResume.push(image);
      if (totalImageForAnalysisResumeByMe.length > 0)
        totalImageForAnalysisResumeByMe =
          totalImageForAnalysisResumeByMe.filter(
            (item) => item.currentTag !== tag,
          ); //removing the duplicate images
      totalImageForAnalysisResumeByMe.push(image);
      // makeRequest(
      //   `/fetchResumeTotImgAnalysisByMe/${inspectionId}/SET`,
      //   totalImageForAnalysisResumeByMe
      // );
    }
  } catch (err) {
    console.log(
      "some error occur whikle saving image feedback msg and image  ::::::  ",
      err,
    );
  }
};

export const isImgExistFeedbackList = async (tag, inspectionId) => {
  let makeReqForMsg = await makeRequest(
    `/fetchResumeImageFeedbackMsg/${inspectionId}/GET`,
  );
  if (makeReqForMsg.ok && makeReqForMsg.status === 200) {
    const totImgMsg = await makeReqForMsg.json();
    if (
      totImgMsg &&
      Object.keys(totImgMsg).length !== 0 &&
      Object.keys(totImgMsg).includes(tag)
    ) {
      return true;
    }
  }
  return false;
};

export const setImageFeedbackResumeStatus = async (
  feedbackSt,
  feedbackBtnStatus,
  inspId,
) => {
  try {
    if (inspectionId || inspId || insId) {
      imageFeedbackStatusNBtn[0] = feedbackSt;
      imageFeedbackStatusNBtn[1] = feedbackBtnStatus;
      makeRequest(
        `/fetchResumeImagefeedbackStatus/${insId ? insId : inspId}/SET`,
        {
          data: imageFeedbackStatusNBtn,
        },
      );
      imageFeedbackCount = 0;
      setImgFeedbackCountResume(false, inspId);
    }
  } catch (err) {
    console.log(
      "some error occur whikle saving image feedback status  ::::::  ",
      err,
    );
  }
};

export const getImageFeedbackMsg = async () => {
  let makeReqForMsg = await makeRequest(
    `/fetchResumeImageFeedbackMsg/${inspectionId}/GET`,
  );
  if (makeReqForMsg.ok && makeReqForMsg.status === 200) {
    const totImgMsg = await makeReqForMsg.json();
    if (totImgMsg && Object.keys(totImgMsg).length !== 0) {
      setTotalImageFeedbackMssgResume(totImgMsg);
      return totImgMsg;
    }
  }
  return "noFeedback";
};

const setImgFeedbackCountResume = async (flag, inspId) => {
  try {
    if (flag) {
      ++imageFeedbackCount;
      await makeRequest(
        `/fetchResumeImgFeedbackCount/${inspectionId ? inspectionId : inspId
        }/SET`,
        {
          data: imageFeedbackCount,
        },
      );
    } else {
      await makeRequest(
        `/fetchResumeImgFeedbackCount/${inspectionId ? inspectionId : inspId
        }/SET`,
        {
          data: 0,
        },
      );
    }
  } catch (err) {
    console.log("image feedback count set error ", err);
  }
};

export const setRedisConfigData = async (
  inspectionId,
  conditions,
  mandatoryConditions,
  subMandatoryConditions,
  subConditions,
  subConditionSub,
  subMandatorySub,
) => {
  try {
    if (inspectionId) {
      //console.log("conditions in utils to store in redis : ", subConditionSub, subMandatorySub);
      await makeRequest(`/redisConfigValue/${inspectionId}/SET`, {
        conditions: conditions,
        mandatoryConditions: mandatoryConditions,
        subMandatoryConditions: subMandatoryConditions,
        subConditions: subConditions,
        subConditionSub: subConditionSub,
        subMandatorySub: subMandatorySub,
      });
    }
  } catch (error) {
    console.log(error);
  }
};

export const setRedisCountData = async (inspectionId, count) => {
  try {
    if (inspectionId) {
      await makeRequest(`/redisCountValue/${inspectionId}/SET`, {
        data: count,
      });
    }
  } catch (error) {
    console.log(error);
  }
};

export const makeRequestVideo = async (DATA) => {
  totalImagesQueue = totalImagesQueue + 1;
  totalVideos++;
  try {
    const res = await fetch("/uploadvideo", {
      method: "POST",
      body: DATA,
    });
    if (res.ok) {
      res.json().then((res1) => {
        if (res1.status === "error") {
          totalVideos--;
        } else if (res1.status === "success") {
          totalVideos--;
        }
      });
    } else {
      totalVideos--;
    }
    return res;
  } catch (e) {
    totalVideos--;
  }
};
export const getCountData = () => {
  return count >= 1;
};

const loadImage = (src) => {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => resolve(img);
    img.onerror = (error) => reject(error);
    img.src = src;
  });
};

// ------------Niranjan Plate Recognition API Call Start ----------------
// const simpleFetch = async (url, options) => {
//   try {
//     const response = await fetch(url, options);
//     return response;
//   } catch (error) {
//     // Log network or unhandled fetch error
//     console.error("Fetch operation failed:", error);
//     throw error;
//   }
// };
// const base64ToWebp = async (image) => {
//   const originalImage = await loadImage(image);
//   const canvas = document.createElement("canvas");
//   canvas.width = originalImage.width;
//   canvas.height = originalImage.height;
//   canvas.getContext("2d").drawImage(originalImage, 0, 0, originalImage.width, originalImage.height);

//   // Convert to WebP Blob without resizing
//   const compressedBlob = await new Promise(resolve => {
//     canvas.toBlob(
//       (blob) => {
//         resolve(blob);
//       },
//       "image/webp", // Use the WebP format
//       0.95 // Set a high quality (e.g., 95%)
//     );
//   });
//   return compressedBlob;
// }
// const callNiranjan = async (imageFile, regionsString = '') => {

//   const API_TOKEN = "35cfc9df562476d530d83ad39bb5e8325c4a3bf0";
//   const API_ENDPOINT = 'https://api.platerecognizer.com/v1/plate-reader/';

//   // const API_TOKEN = process.env.PLATE_RECOGNITION_API_KEY;
//   // const API_ENDPOINT = process.env.PLATE_RECOGNITION_API_ENDPOINT;

//   const formData = new FormData();
//   let blobImg = await base64ToWebp(imageFile)
//   formData.append('upload', blobImg, imageFile.name || 'image.jpg');

//   const regions = regionsString.split(',').map(r => r.trim()).filter(r => r.length > 0);
//   if (regions.length > 0) {
//     formData.append('regions', regions.join(','));
//   }

//   const fetchOptions = {
//     method: 'POST',
//     headers: {
//       'Authorization': `Token ${API_TOKEN}`,
//     },
//     body: formData
//   };

//   const response = await simpleFetch(API_ENDPOINT, fetchOptions);
//   const data = await response.json();

//   let resultColor = 'N/A'

//   if (!response.ok) {
//     const errorDetail = data.detail || JSON.stringify(data);
//     console.error("API Error Response Data:", data);
//     return resultColor;
//   }

//   if (data.results && data.results.length > 0) {
//     const result = data.results[0];
//     try {
//       if (result.color && result.color.length > 0) {
//         resultColor = result.color[0].color || resultColor;
//       }
//     } catch (e) {
//       console.error("Error during result data parsing:", e);
//     }
//   }
//   console.log('recognize_plate data:', resultColor);
//   setColor(resultColor);
//   return resultColor;
// }
// ------------Niranjan Plate Recognition API Call Ends ----------------

const blackPercentageCount = (data, width, height) => {
  let blackPixels = 0;
  const totalPixels = width * height;
  const threshold = 30; // Max R, G, B value for a pixel to be considered 'black'

  for (let i = 0; i < data.length; i += 4) {
    const r = data[i];
    const g = data[i + 1];
    const b = data[i + 2];

    if (r < threshold && g < threshold && b < threshold) {
      blackPixels++;
    }
  }
  return (blackPixels / totalPixels) * 100;
};

const processAndCaptureImage = async (file) => {
  const startTime = performance.now();
  let img = await loadImage(file);
  const cnv = document.createElement("canvas");
  cnv.width = img.naturalWidth;
  cnv.height = img.naturalHeight;
  const context = cnv.getContext("2d");

  // Set quality before drawing the image onto the canvas
  context.imageSmoothingEnabled = true;
  context.imageSmoothingQuality = "high";

  context.drawImage(img, 0, 0, cnv.width, cnv.height);

  //calling niranjan plate recognition api to get color
  // let color = await callNiranjan(file);
  let color = "black";

  const imageData = context.getImageData(0, 0, cnv.width, cnv.height);
  const data = imageData.data;

  // Calculate black percentage
  const calculatedBlackPercentage = blackPercentageCount(
    data,
    cnv.width,
    cnv.height,
  );
  console.log("Black Percentage:", calculatedBlackPercentage.toFixed(2));
  // --- STEP 1: Calculate Minimum/Maximum Values (Auto-Leveling) ---
  let minR = 255,
    maxR = 0;
  let minG = 255,
    maxG = 0;
  let minB = 255,
    maxB = 0;

  for (let i = 0; i < data.length; i += 4) {
    minR = Math.min(minR, data[i]);
    maxR = Math.max(maxR, data[i]);
    minG = Math.min(minG, data[i + 1]);
    maxG = Math.max(maxG, data[i + 1]);
    minB = Math.min(minB, data[i + 2]);
    maxB = Math.max(maxB, data[i + 2]);
  }

  // Determine the adjustment factors
  const rangeR = maxR - minR;
  const rangeG = maxG - minG;
  const rangeB = maxB - minB;

  // Enhancement Parameters
  let SHADOW_LIFT_MAX = 0; // The maximum amount a pixel can be brightened
  let CONTRAST_BOOST = 0; // ADDED: Small contrast value (0-255)

  // Determine LIFT_MAX and CONTRAST_BOOST based on calculated black percentage and car color
  if (calculatedBlackPercentage > 25) {
    if (
      color &&
      color !== "N/A" &&
      ["black", "dark", "dark grey"].includes(color.toLowerCase())
    ) {
      SHADOW_LIFT_MAX = 70;
      CONTRAST_BOOST = 18;
    } else {
      SHADOW_LIFT_MAX = 50;
      CONTRAST_BOOST = 12;
    }
  } else if (calculatedBlackPercentage > 15) {
    if (
      color &&
      color !== "N/A" &&
      ["black", "dark", "dark grey"].includes(color.toLowerCase())
    ) {
      SHADOW_LIFT_MAX = 40;
      CONTRAST_BOOST = 12;
    } else {
      SHADOW_LIFT_MAX = 30;
      CONTRAST_BOOST = 8;
    }
  } else if (calculatedBlackPercentage > 5) {
    SHADOW_LIFT_MAX = 20;
    CONTRAST_BOOST = 5;
  } else {
    SHADOW_LIFT_MAX = 5;
    CONTRAST_BOOST = 0;
  }

  // Calculate contrast factor AFTER CONTRAST_BOOST is determined
  const contrastFactor =
    (259 * (CONTRAST_BOOST + 255)) / (255 * (259 - CONTRAST_BOOST));

  // --- STEP 2: Apply Auto-Leveling (Normalization) and High Brightness Add ---
  for (let i = 0; i < data.length; i += 4) {
    let r = data[i];
    let g = data[i + 1];
    let b = data[i + 2];

    // Auto-Leveling (Stretching histogram to full 0-255 range)
    if (rangeR > 0) r = (255 * (r - minR)) / rangeR;
    if (rangeG > 0) g = (255 * (g - minG)) / rangeG;
    if (rangeB > 0) b = (255 * (b - minB)) / rangeB;

    // 2b. ADDED: Contrast Boost (Applied to the normalized values)
    r = contrastFactor * (r - 128) + 128;
    g = contrastFactor * (g - 128) + 128;
    b = contrastFactor * (b - 128) + 128;

    // --- 2c. Weighted Shadow Lift (CRITICAL CHANGE) ---
    // 1. Calculate the current luminance (brightness) after auto-leveling/contrast.
    // 2. The lift amount is large for dark pixels and approaches 0 for bright pixels.
    const currentLum = (r + g + b) / 3;

    // This calculates a multiplier: 1.0 for dark (Lum=0), 0.0 for bright (Lum=255)
    const liftMultiplier = 1 - currentLum / 255;

    // Calculate the final lift amount: Max Lift * Multiplier
    const finalLift = SHADOW_LIFT_MAX * liftMultiplier;

    // Apply lift
    r += finalLift;
    g += finalLift;
    b += finalLift;

    // Final Clamp and Save (0-255)
    data[i] = Math.min(255, Math.max(0, r));
    data[i + 1] = Math.min(255, Math.max(0, g));
    data[i + 2] = Math.min(255, Math.max(0, b));
  }

  // Put the modified image data back onto the canvas
  context.putImageData(imageData, 0, 0);

  // const imgData = cnv.toDataURL("image/jpeg", 0.9); // Use 90% quality for JPEG
  const imgData =
    getWebpImageFormat() && !iosDevice
      ? cnv.toDataURL("image/webp", imgQualityFactor)
      : cnv.toDataURL("image/jpeg");

  const endTime = performance.now();
  // console.log((endTime - startTime).toFixed(2));
  return imgData;
};

const base64ToWebp = async (image, allowUpgration, weight, height) => {
  if (allowUpgration) {
    const image1 = await loadImage(image);
    const canvas = document.createElement("canvas");
    canvas.width = weight;
    canvas.height = height;
    canvas.getContext("2d").drawImage(image1, 0, 0, weight, height);

    const compressedBlob = await new Promise((resolve) => {
      canvas.toBlob(
        (blob) => {
          resolve(blob);
        },
        "image/jpeg", // Use the WebP format
        imgQualityFactor, // Set a high quality (e.g., 95%)
      );
    });

    //downloadWebp(compressedBlob);

    return compressedBlob;
  } else {
    const originalImage = await loadImage(image);
    const canvas = document.createElement("canvas");
    canvas.width = originalImage.width;
    canvas.height = originalImage.height;
    canvas
      .getContext("2d")
      .drawImage(
        originalImage,
        0,
        0,
        originalImage.width,
        originalImage.height,
      );

    const compressedBlob = await new Promise((resolve) => {
      canvas.toBlob(
        (blob) => {
          resolve(blob);
        },
        "image/jpeg", // Use the WebP format
        imgQualityFactor, // Set a high quality (e.g., 95%)
      );
    });

    //downloadWebp(compressedBlob);

    return compressedBlob;
  }
};

export const addImageToList = async (image, conversion) => {
  if (stopResizing[0]) {
    if (Array.isArray(image)) {
      if (imageEnhancement) {
        let qualityImproImg = await processAndCaptureImage(image[0].imgData);
        image[0]["imgData"] = qualityImproImg;
      }
      if (iosDevice && getWebpImageFormat()) {
        const convertedImage = await base64ToWebp(
          image[0].imgData,
          false,
          0,
          0,
        );
        image[0]["imgData"] = convertedImage;
      }
      imageQueue.push(image);
    } else {
      if (image.tag === "Selfie") {
        if (imageEnhancement) {
          let qualityImproImg = await processAndCaptureImage(image.imgData);
          image["imgData"] = qualityImproImg;
        }
        if (iosDevice && getWebpImageFormat()) {
          const convertedImage = await base64ToWebp(image.imgData, false, 0, 0);
          image["imgData"] = convertedImage;
        }
        imageQueue.push(image);
      } else {
        if (image["tag"] === "uploadImage" || conversion === "No Conversion") {
          if (imageEnhancement && conversion === "No Conversion") {
            let qualityImproImg = await processAndCaptureImage(image.imgData);
            image["imgData"] = qualityImproImg;
          }
          if (iosDevice && getWebpImageFormat()) {
            const convertedImage = await base64ToWebp(
              image.imgData,
              false,
              0,
              0,
            );
            image["imgData"] = convertedImage;
          }
          imageQueue.push(image);
        } else {
          const image1 = await loadImage(image.imgData);
          const canvas = document.createElement("canvas");
          const context = canvas.getContext("2d");
          canvas.width = stopResizing[1].width;
          canvas.height = stopResizing[1].height;
          context.drawImage(
            image1,
            0,
            0,
            stopResizing[1].width,
            stopResizing[1].height,
          );
          let base64Data =
            getWebpImageFormat() && !iosDevice
              ? canvas.toDataURL("image/webp", imgQualityFactor)
              : canvas.toDataURL("image/jpeg");
          if (imageEnhancement) {
            let qualityImproImg = await processAndCaptureImage(base64Data);
            image["imgData"] = qualityImproImg;
          } else image["imgData"] = base64Data;
          if (iosDevice && getWebpImageFormat()) {
            const convertedImage = await base64ToWebp(
              image.imgData,
              false,
              0,
              0,
            );
            image["imgData"] = convertedImage;
          }
          imageQueue.push(image);
        }
      }
    }
  } else {
    if (Array.isArray(image)) {
      if (imageEnhancement) {
        let qualityImproImg = await processAndCaptureImage(image[0].imgData);
        image[0]["imgData"] = qualityImproImg;
      }
      if (iosDevice && getWebpImageFormat()) {
        const convertedImage = await base64ToWebp(
          image[0].imgData,
          false,
          0,
          0,
        );
        image[0]["imgData"] = convertedImage;
      }
      imageQueue.push(image);
    } else {
      if (image.tag === "Selfie") {
        if (imageEnhancement) {
          let qualityImproImg = await processAndCaptureImage(image.imgData);
          image["imgData"] = qualityImproImg;
        }
        if (iosDevice && getWebpImageFormat()) {
          const convertedImage = await base64ToWebp(image.imgData, false, 0, 0);
          image["imgData"] = convertedImage;
        }
        imageQueue.push(image);
      } else {
        if (image["tag"] === "uploadImage" || conversion === "No Conversion") {
          if (imageEnhancement && conversion === "No Conversion") {
            let qualityImproImg = await processAndCaptureImage(image.imgData);
            image["imgData"] = qualityImproImg;
          }
          if (iosDevice && getWebpImageFormat()) {
            const convertedImage = await base64ToWebp(
              image.imgData,
              false,
              0,
              0,
            );
            image["imgData"] = convertedImage;
          }
          imageQueue.push(image);
        } else {
          if (["client_hiib", "client_hiib_uat"].includes(clientID)) {
            const image1 = await loadImage(image.imgData);
            const canvas = document.createElement("canvas");
            const context = canvas.getContext("2d");
            canvas.width = 1080;
            canvas.height = 720;
            context.drawImage(image1, 0, 0, 1080, 720);
            let base64Data =
              getWebpImageFormat() && !iosDevice
                ? canvas.toDataURL("image/webp", imgQualityFactor)
                : canvas.toDataURL("image/jpeg");
            if (imageEnhancement) {
              let qualityImproImg = await processAndCaptureImage(base64Data);
              image["imgData"] = qualityImproImg;
            } else image["imgData"] = base64Data;
            if (iosDevice && getWebpImageFormat()) {
              const convertedImage = await base64ToWebp(
                image.imgData,
                false,
                0,
                0,
              );
              image["imgData"] = convertedImage;
            }
            imageQueue.push(image);
          } else {
            const image1 = await loadImage(image.imgData);
            const canvas = document.createElement("canvas");
            const context = canvas.getContext("2d");
            canvas.width = 1920;
            canvas.height = 1080;
            context.drawImage(image1, 0, 0, 1920, 1080);
            let base64Data =
              getWebpImageFormat() && !iosDevice
                ? canvas.toDataURL("image/webp", imgQualityFactor)
                : canvas.toDataURL("image/jpeg");
            if (imageEnhancement) {
              let qualityImproImg = await processAndCaptureImage(base64Data);
              image["imgData"] = qualityImproImg;
            } else image["imgData"] = base64Data;
            if (iosDevice && getWebpImageFormat()) {
              const convertedImage = await base64ToWebp(
                image.imgData,
                false,
                0,
                0,
              );
              image["imgData"] = convertedImage;
            }
            imageQueue.push(image);
          }
        }
      }
    }
  }
  totalImagesQueue = totalImagesQueue + 1;
};

export const resumeFlowFinalSubmitHandler = async (currentBlock, isPortraitApp) => {
  if (Object.keys(mandatory).includes(currentBlock)) {
    mandatory[currentBlock] = "completed";
  }
  condition[currentBlock] = "completed";
  setRedisConfigData(
    inspectionId,
    condition,
    mandatory,
    subMandatory,
    subCondition,
    isPortraitApp && subMandatorySub,
    isPortraitApp && subConditionSub,
  );
};

export const remove360CompleteFlagFeedbackResume = async (currentBlock) => {
  if (Object.keys(mandatory).includes(currentBlock)) {
    mandatory[currentBlock] = "pending";
  }
  condition[currentBlock] = "pending";
};

export const imageUpload = async (inspectionId) => {
  let startDateLog = 0,
    endDateLog = null;

  if (clientID === "client_507_testing") {
    imageQueue.splice(0, 1);
    imageSending = false;
    return;
  }

  if (logBugs) {
    imginterval = setInterval(() => {
      imgStatus(inspectionId);
      logBugs = false;
    }, 100);
  }

  if (imageQueue.length === 0 || imageSending) return;

  imageSending = true;

  const currentImage = imageQueue[0]; // ✅ FIX: capture safely
  const currentImageTag = Array.isArray(currentImage)
    ? currentImage[0]?.tag
    : currentImage?.tag;

  if (["client_1630", "client_1630_uat", "client_1630_prod", "client_1630_dev", "anuj_garg", "client_1630_stagging"].includes(clientID)) {
    if (kiwi360TagList.hasOwnProperty(currentImage.tag)) {
      if (kiwi360TagList[currentImage.tag] !== 1) {
        kiwi360TagList[currentImage.tag] = 1;
        currentImage.tag = currentImage.tag.replace("_interim", "");
      }
    }
  }

  try {
    if (count === null) {
      backupImages.push(currentImage);
      imageQueue.shift();
      imageSending = false;
      return;
    }

    let res;

    if (iosDevice && getWebpImageFormat()) {
      const formData = new FormData();

      const imageBlob = Array.isArray(currentImage)
        ? currentImage[0].imgData
        : currentImage.imgData;

      const imageSizeInBytes = imageBlob.size;

      formData.append("image", imageBlob, "image.webp");

      let dataWithoutBlob;

      if (Array.isArray(currentImage)) {
        const [first, second] = currentImage;
        const { imgData, ...firstWithoutBlob } = first;
        dataWithoutBlob = [firstWithoutBlob, second];
      } else {
        dataWithoutBlob = { ...currentImage };
        delete dataWithoutBlob.imgData;
      }

      const payload = {
        token,
        file: dataWithoutBlob,
        email: userEmail,
        geolocation: location,
        count,
        inspectionId,
        clientID,
        resumeFlag: resumeFlowAllow,
        storeInRedis: !Array.isArray(currentImage),
        hiibRedisSingleImageTag: Array.isArray(currentImage)
          ? ""
          : currentImage?.tag?.includes(":")
            ? currentImage.tag
            : currentImage?.currentBlockName || "",
        vmgFlowType,
        vmgUrl,
        authorization,
        hyundaiData,
        timeStampFlag: resumeTimestampFlag,
        resumeTimeStampFlagSecond:
          resumeTimestampFlag &&
          resumeTimeStamoSecondFlag &&
          resumeTimeStamoSecondFlagCount,
        timeStamp: Date.now(),
        ...(inputMetaDataFlag && { inputMetaData: inputMetaData }),
        ...(kotakVehicleDataFlag && { kotakVehicleData: kotakVehicleData }),
      };

      const dataString = JSON.stringify(payload);
      const encoder = new TextEncoder();
      const dataSizeInBytes = encoder.encode(dataString).length;

      const totalPayloadSizeInBytes = imageSizeInBytes + dataSizeInBytes;
      const totalPayloadSizeInKB = totalPayloadSizeInBytes / 1024;

      imageSize = totalPayloadSizeInKB.toFixed(2);

      console.log(`Total payload size: ${imageSize} KB`);

      formData.append("data", dataString);

      startDateLog = Date.now();

      res = await makeRequest("/imageUploadIosWeb", formData, true);
    } else {
      const payload = {
        token,
        file: currentImage,
        email: userEmail,
        geolocation: location,
        count,
        inspectionId,
        clientID,
        resumeFlag: resumeFlowAllow,
        storeInRedis: !Array.isArray(currentImage),
        hiibRedisSingleImageTag: Array.isArray(currentImage)
          ? ""
          : currentImage?.tag?.includes(":")
            ? currentImage.tag
            : currentImage?.currentBlockName || "",
        vmgFlowType,
        vmgUrl,
        authorization,
        hyundaiData,
        webpFormat: getWebpImageFormat(),
        timeStampFlag: resumeTimestampFlag,
        resumeTimeStampFlagSecond:
          resumeTimestampFlag &&
          resumeTimeStamoSecondFlag &&
          resumeTimeStamoSecondFlagCount,
        timeStamp: Date.now(),
        ...(inputMetaDataFlag && { inputMetaData: inputMetaData }),
        ...(kotakVehicleDataFlag && { kotakVehicleData: kotakVehicleData }),
      };

      const dataString = JSON.stringify(payload);
      const encoder = new TextEncoder();
      const dataSizeInBytes = encoder.encode(dataString).length;

      const totalPayloadSizeInKB = dataSizeInBytes / 1024;
      imageSize = totalPayloadSizeInKB.toFixed(2);

      console.log(`Total payload size: ${imageSize} KB`);

      startDateLog = Date.now();

      res = await makeRequest("/imageUpload", payload);
    }

    if (
      resumeTimestampFlag &&
      resumeTimeStamoSecondFlag &&
      resumeTimeStamoSecondFlagCount
    ) {
      resumeTimeStamoSecondFlagCount = false;
    }

    if (!res || !res.ok) {
      throw new Error(
        `HTTP error: ${res?.status || "No response From Backend"}`,
      );
    }

    const res1 = await res.json(); // ✅ FIX: proper async

    endDateLog = Date.now();

    if (res1.status === "error") {
      const logDetails = {
        type: "backend",
        imageName: currentImageTag,
        InternetLatency: getInternetLatency(),
        message: res1.message || "Unknown backend error",
        context: res1.context || "imageUpload/backend/imageUploadHandler",
        stack: res1.stack || "",
        imageSize: imageSize ? imageSize : 0,
        timeTakenToUpload: startDateLog ? endDateLog - startDateLog : null,
      };
      pathImageDataHandler(logDetails, inspectionId, "Fail");
      removeGlobalImageQueue(currentImageTag);
      backupImages.push(currentImage);
      imageQueue.shift();
      imageSending = false;
      return;
    }

    // ✅ SUCCESS FLOW
    redyForUpload = true;

    let img = currentImage;

    if (Array.isArray(img)) {
      if (portoModuleList.includes(img[0]["tag"])) {
        portoModuleComplete.push(img[0]["tag"]);
      }
    } else {
      if (portoModuleList.includes(img["tag"])) {
        portoModuleComplete.push(img["tag"]);
      }
    }

    //setting resume flow fetching from redis
    if (resumeFlowAllow && !redisFlowSetFirstTime) {
      redisFlowSetFirstTime = true;
      makeRequest(`/fetchResumeFlow/${inspectionId}/SET`, { flag: true });
    }

    //resume flow code
    if (resumeFlowAllow) {
      //console.log("Setting Redis Config Data for image upload..."); // ✅ LOG
      let image = currentImage;

      if (Array.isArray(image)) {
        const tag = image[0]["tag"];

        if (tag === "WindshieldDamage") {
          windshieldDamageCount++;
          makeRequest(`/windshieldRedisCount/${inspectionId}/SET`, {
            count: windshieldDamageCount,
          });
        } else if (tag === "Damage") {
          damageCount++;
          makeRequest(`/damageRedisCount/${inspectionId}/SET`, {
            count: damageCount,
          });
        }
      } else if (image["tag"].includes(":")) {
        if (image["portraitApp"] && image["portraitApp"]) {

          const currentBlock = image["currentBlockName"];
          const subBlock = image["subBlockName"];

          subConditionSub[currentBlock][subBlock] = "completed";

          if (
            Object.keys(subMandatorySub).includes(currentBlock) &&
            Object.keys(subMandatorySub[currentBlock]).includes(subBlock)
          ) {
            subMandatorySub[currentBlock][subBlock] = "completed";
          }

        }
        else {
          const currentBlock = image["currentBlockName"];
          const subBlock = image["currentSubBlock"];

          subCondition[currentBlock][subBlock] = "completed";

          if (
            Object.keys(subMandatory).includes(currentBlock) &&
            Object.keys(subMandatory[currentBlock]).includes(subBlock)
          ) {
            subMandatory[currentBlock][subBlock] = "completed";
          }

          if (image["imageFeedbackFlag"]) {
            setImageFeedbackMsg(image["currentTag"]);
          }
        }
      } else {
        const tag = image["currentBlockName"];
        if (tag !== undefined) {
          if (Object.keys(mandatory).includes(tag)) {
            mandatory[tag] = "completed";
          }
          condition[tag] = "completed";
        }
      }
      //console.log("setting config data in resume: ", subMandatory, subCondition, subMandatorySub, subConditionSub);
      setRedisConfigData(
        inspectionId,
        condition,
        mandatory,
        subMandatory,
        subCondition,
        subMandatorySub,
        subConditionSub,
      );
    }

    pathImageDataHandler(
      `${currentImageTag} uploaded successfully with size ${imageSize ? imageSize : 0} KB with time taken ${endDateLog - startDateLog
      } ms and time: ${currentImage?.captureTimestamp}`,
      inspectionId,
      "Success",
    );

    ++count;

    removeGlobalImageQueue(currentImageTag);
    imageQueue.shift();
    imageSending = false;

    if (inputMetaDataFlag) inputMetaDataFlag = false;
    if (kotakVehicleDataFlag) kotakVehicleDataFlag = false;
    //save count for resume flow
    if (resumeFlowAllow) {
      //console.log("Setting Redis Count Data for image upload..."); // ✅ LOG
      setRedisCountData(inspectionId, count);
    }
    //console.log("Image upload successful at time:", currentImageTag, currentImage?.captureTimestamp); // ✅ LOG
  } catch (err) {
    console.error("Error during image upload:", err); // ✅ real error
    endDateLog = Date.now();

    console.error("UPLOAD ERROR:", err); // ✅ real error

    const logDetails = {
      type: "frontend",
      message: err.message,
      stack: err.stack || "",
      InternetLatency: getInternetLatency(),
      imageName: currentImageTag,
      context: "imageUpload",
      imageSize: imageSize ? imageSize : 0,
      timeTakenToUpload: startDateLog ? endDateLog - startDateLog : null, // ✅ FIX
    };

    patLogs(err.message, inspectionId);
    pathImageDataHandler(logDetails, inspectionId, "Fail");

    removeGlobalImageQueue(currentImageTag);
    backupImages.push(currentImage);
    imageQueue.shift();
    imageSending = false;
  }
};

// export const imageUpload = async (inspectionId) => {
//   let startDateLog = 0, endDateLog = 0; // extra log
//   if (clientID === "client_507_testing") {
//     imageQueue.splice(0, 1);
//     imageSending = false;
//     return;
//   }
//   if (logBugs) {
//     imginterval = setInterval(() => {
//       imgStatus(inspectionId);
//       logBugs = false;
//     }, 100);
//   }
//   if (imageQueue.length != 0 && imageSending != true) {
//     imageSending = true;
//     // let abortController = new AbortController();
//     // clearInterval(interval)

//     // interval = setInterval(() =>{
//     //   abortController.abort();
//     //   backupImages.push(imageQueue[0])
//     //   imageQueue.splice(0, 1)
//     //   imageSending = false
//     //   clearInterval(interval)
//     // }, 3000)

//     try {
//       if (count === null) {
//         backupImages.push(imageQueue[0]);
//         imageQueue.splice(0, 1);
//         imageSending = false;
//       } else {
//         let res;
//         if (iosDevice && getWebpImageFormat()) {
//           const formData = new FormData();
//           let imageBlob;
//           if (Array.isArray(imageQueue[0]))
//             imageBlob = imageQueue[0][0].imgData;
//           else imageBlob = imageQueue[0].imgData;
//           const imageSizeInBytes = imageBlob.size;
//           formData.append("image", imageBlob, "image.webp");
//           let dataWithoutBlob;
//           if (Array.isArray(imageQueue[0])) {
//             dataWithoutBlob = [];
//             const [first, second] = imageQueue[0];
//             const { imgData, ...firstWithoutBlob } = first;
//             dataWithoutBlob = [firstWithoutBlob, second];
//             // let firstelement = { ...imageQueue[0][0] };
//             // delete firstelement.imgData;
//             // dataWithoutBlob.push(firstelement);
//             // dataWithoutBlob.push(imageQueue[0][1]);
//           } else {
//             dataWithoutBlob = { ...imageQueue[0] };
//             delete dataWithoutBlob.imgData;
//           }
//           let payload = {
//             token,
//             file: dataWithoutBlob,
//             email: userEmail,
//             geolocation: location,
//             count,
//             inspectionId,
//             clientID: clientID,
//             resumeFlag: resumeFlowAllow,
//             storeInRedis: !Array.isArray(imageQueue[0]),
//             hiibRedisSingleImageTag: Array.isArray(imageQueue?.[0])
//               ? ""
//               : imageQueue?.[0]?.tag?.includes(":")
//                 ? imageQueue[0].tag
//                 : imageQueue?.[0]?.currentBlockName || "",
//             vmgFlowType,
//             vmgUrl,
//             authorization,
//             hyundaiData,
//             timeStampFlag: resumeTimestampFlag,
//             resumeTimeStampFlagSecond:
//               resumeTimestampFlag &&
//               resumeTimeStamoSecondFlag &&
//               resumeTimeStamoSecondFlagCount,
//             timeStamp: Date.now(),
//             ...(inputMetaDataFlag && { inputMetaData: inputMetaData }),
//             ...(kotakVehicleDataFlag && { kotakVehicleData: kotakVehicleData }),
//           };
//           const dataString = JSON.stringify(payload);
//           const encoder = new TextEncoder();
//           const dataSizeInBytes = encoder.encode(dataString).length;
//           const totalPayloadSizeInBytes = imageSizeInBytes + dataSizeInBytes;
//           const totalPayloadSizeInKB = totalPayloadSizeInBytes / 1024;
//           console.log(
//             `Total payload size: ${totalPayloadSizeInKB.toFixed(2)} KB`,
//           );
//           formData.append("data", JSON.stringify(payload));
//           imageSize = totalPayloadSizeInKB.toFixed(2); //extra logs
//           startDateLog = new Date().getTime(); //extra logs
//           endDateLog = 0; //extra logs
//           res = await makeRequest("/imageUploadIosWeb", formData, true);
//         } else {
//           let payload = {
//             token,
//             file: imageQueue[0],
//             email: userEmail,
//             geolocation: location,
//             count,
//             inspectionId,
//             clientID: clientID,
//             resumeFlag: resumeFlowAllow,
//             storeInRedis: !Array.isArray(imageQueue[0]),
//             hiibRedisSingleImageTag: Array.isArray(imageQueue?.[0])
//               ? ""
//               : imageQueue?.[0]?.tag?.includes(":")
//                 ? imageQueue[0].tag
//                 : imageQueue?.[0]?.currentBlockName || "",
//             vmgFlowType,
//             vmgUrl,
//             authorization,
//             hyundaiData,
//             webpFormat: getWebpImageFormat(),
//             timeStampFlag: resumeTimestampFlag,
//             resumeTimeStampFlagSecond:
//               resumeTimestampFlag &&
//               resumeTimeStamoSecondFlag &&
//               resumeTimeStamoSecondFlagCount,
//             timeStamp: Date.now(),
//             ...(inputMetaDataFlag && { inputMetaData: inputMetaData }),
//             ...(kotakVehicleDataFlag && { kotakVehicleData: kotakVehicleData }),
//           };
//           const dataString = JSON.stringify(payload);
//           const encoder = new TextEncoder();
//           const dataSizeInBytes = encoder.encode(dataString).length;
//           const totalPayloadSizeInBytes = dataSizeInBytes;
//           const totalPayloadSizeInKB = totalPayloadSizeInBytes / 1024;
//           console.log(
//             `Total payload size: ${totalPayloadSizeInKB.toFixed(2)} KB`,
//           );
//           imageSize = totalPayloadSizeInKB.toFixed(2); //extra logs
//           startDateLog = new Date().getTime(); //extra logs
//           endDateLog = 0; //extra logs
//           res = await makeRequest("/imageUpload", payload);
//         }
//         if (
//           resumeTimestampFlag &&
//           resumeTimeStamoSecondFlag &&
//           resumeTimeStamoSecondFlagCount
//         )
//           resumeTimeStamoSecondFlagCount = false;
//         if (res.ok) {
//           res.json().then((res1) => {
//             endDateLog = new Date().getTime(); //extra logs
//             if (res1.status === "error") {
//               // clearInterval(interval)
//               let logDetails = {
//                 type: "backend",
//                 imageName: imageQueue[0]["tag"],
//                 InternetLatency: getInternetLatency(),
//                 message: res1.message || "Unknown backend error",
//                 context:
//                   res1.context || "imageUpload/backend/imageUploadHandler",
//                 stack: res1.stack || "",
//                 imageSize: imageSize, //extra logs
//                 timeTakenToUpload: endDateLog - startDateLog, //extra logs
//               };
//               pathImageDataHandler(logDetails, inspectionId, "Fail");
//               removeGlobalImageQueue(imageQueue[0]["tag"]);
//               backupImages.push(imageQueue[0]);
//               imageQueue.splice(0, 1);
//               imageSending = false;
//             } else if (res1.status === "success") {
//               redyForUpload = true;
//               // clearInterval(interval)
//               let img = imageQueue[0];
//               if (Array.isArray(img)) {
//                 if (portoModuleList.includes(img[0]["tag"])) {
//                   portoModuleComplete.push(img[0]["tag"]);
//                 }
//               } else {
//                 if (portoModuleList.includes(imageQueue[0]["tag"])) {
//                   portoModuleComplete.push(imageQueue[0]["tag"]);
//                 }
//               }

//               //setting resume flow fetching from redis
//               if (resumeFlowAllow && !redisFlowSetFirstTime) {
//                 redisFlowSetFirstTime = true;
//                 makeRequest(`/fetchResumeFlow/${inspectionId}/SET`, {
//                   flag: true,
//                 });
//               }

//               //resume flow code
//               if (resumeFlowAllow) {
//                 let image = imageQueue[0];
//                 let tag;
//                 let currentBlock;
//                 let subBlock;

//                 //for ZIZO
//                 if (Array.isArray(image)) {
//                   tag = image[0]["tag"];
//                   if (tag === "WindshieldDamage") {
//                     windshieldDamageCount++;
//                     makeRequest(`/windshieldRedisCount/${inspectionId}/SET`, {
//                       count: windshieldDamageCount,
//                     });
//                   } else if (tag === "Damage") {
//                     damageCount++;
//                     makeRequest(`/damageRedisCount/${inspectionId}/SET`, {
//                       count: damageCount,
//                     });
//                   }
//                 } else if (image["tag"].includes(":")) {
//                   //for multiple images
//                   currentBlock = image["currentBlockName"];
//                   subBlock = image["currentSubBlock"];
//                   subCondition[currentBlock][subBlock] = "completed";
//                   if (
//                     Object.keys(subMandatory).includes(currentBlock) &&
//                     Object.keys(subMandatory[currentBlock]).includes(subBlock)
//                   ) {
//                     subMandatory[currentBlock][subBlock] = "completed";
//                   }
//                   if (image["imageFeedbackFlag"]) {
//                     setImageFeedbackMsg(image["currentTag"]);
//                   }
//                 } else {
//                   tag = image["currentBlockName"];
//                   if (tag !== undefined) {
//                     if (Object.keys(mandatory).includes(tag)) {
//                       mandatory[tag] = "completed";
//                     }
//                     condition[tag] = "completed";
//                   }
//                 }
//                 setRedisConfigData(
//                   inspectionId,
//                   condition,
//                   mandatory,
//                   subMandatory,
//                   subCondition,
//                 );
//               }
//               pathImageDataHandler(
//                 `${imageQueue[0]["tag"]} uploaded successfully with size ${imageSize} KB with time taken ${endDateLog - startDateLog} ms`,
//                 inspectionId,
//                 "Success",
//               );
//               ++count;
//               removeGlobalImageQueue(imageQueue[0]["tag"]);
//               imageQueue.splice(0, 1);
//               imageSending = false;
//               if (inputMetaDataFlag) inputMetaDataFlag = false;
//               if (kotakVehicleDataFlag) kotakVehicleDataFlag = false;
//               //save count for resume flow
//               if (resumeFlowAllow) {
//                 setRedisCountData(inspectionId, count);
//               }
//             }
//           });
//         } else {
//           removeGlobalImageQueue(imageQueue[0]["tag"]);
//           backupImages.push(imageQueue[0]);
//           imageQueue.splice(0, 1);
//           imageSending = false;
//         }
//       }
//     } catch (err) {
//       console.log(err);
//       let logDetails = {
//         type: "frontend",
//         message: err.message,
//         InternetLatency: getInternetLatency(),
//         imageName: imageQueue[0]["tag"],
//         context: "imageUpload",
//         stack: err.stack || "",
//         imageSize: imageSize, //extra logs
//         timeTakenToUpload: endDateLog - startDateLog, //extra logs
//       };
//       patLogs(err.message, inspectionId);
//       pathImageDataHandler(logDetails, inspectionId, "Fail");
//       removeGlobalImageQueue(imageQueue[0]["tag"]);
//       backupImages.push(imageQueue[0]);
//       imageQueue.splice(0, 1);
//       imageSending = false;
//     }
//   }
// };

export const sendCoveredArea = async (
  allGreen,
  regionsMap,
  clientId,
  caseId,
  inspectionId,
) => {
  let region = {};
  let region_view = {};
  let allPartsCovered = 0;
  let color = ["grey", "#02CCFE", "green"];
  if (
    [
      "porto_seguros",
      "porto_seguros_uat",
      "client_834",
      "client_834_uat",
    ].includes(clientId)
  ) {
    color = ["grey", "#02CCFE", "green"];
  } else if (["client_1433"].includes(clientId)) {
    color = ["grey", "#FFFF00", "green"];
  }

  region.F = regionsMap["Front"];
  region.B = regionsMap["Rear"];
  region.LFI = regionsMap["Front-Isometric-Left"];
  region.RFI = regionsMap["Front-Isometric-Right"];
  region.LRI = regionsMap["Rear-Isometric-Left"];
  region.RRI = regionsMap["Rear-Isometric-Right"];
  region.L = regionsMap["Side-Left"];
  region.R = regionsMap["Side-Right"];

  region_view.F = color[parseInt(regionsMap["Front"])];
  region_view.B = color[parseInt(regionsMap["Rear"])];
  region_view.LFI = color[parseInt(regionsMap["Front-Isometric-Left"])];
  region_view.RFI = color[parseInt(regionsMap["Front-Isometric-Right"])];
  region_view.LRI = color[parseInt(regionsMap["Rear-Isometric-Left"])];
  region_view.RRI = color[parseInt(regionsMap["Rear-Isometric-Right"])];
  region_view.L = color[parseInt(regionsMap["Side-Left"])];
  region_view.R = color[parseInt(regionsMap["Side-Right"])];

  allPartsCovered = Object.values(color).every((value) => value === "green")
    ? 1
    : 0;

  const res = await makeRequest("/sendAreaCovered", {
    allGreen: allPartsCovered,
    region,
    region_view,
    retake,
    token,
    clientId,
    caseId,
    inspectionId,
  });
};

export const setLog = async (message) => {
  await makeRequest("/setLog", { message, inspectionId });
};

export const backupImagesStatus = () => {
  if (backupImages.length > 0 && imageQueue.length === 0) {
    return true;
  } else {
    return false;
  }
};

export const checkResumeImgFeedbackUploadTagHandler = async (
  inspectionId,
  config,
) => {
  try {
    const result = await makeRequest(
      `/fetchResumeCaseInImgFeedback/${inspectionId}`,
    );
    if (result && Object.keys(config).includes("imageFeedback")) {
    } else return [];
  } catch (err) {
    console.log(
      "faces error while fetching niranjan resume tag in utils :: ",
      err,
    );
    return [];
  }
};

// export const finalUpload = async (imageFeedbackAllow, resumeUsedFlag) => {
//   let startDateLog = 0, endDateLog = 0; // extra log
//   if (imageQueue.length > 0) {
//     return false;
//   }
//   if (globalImageQueue.length > 0 && imageQueue.length === 0) {
//     globalImageQueue.map((image) => {
//       addImageToList(image);
//     });
//     globalImageQueue = [];
//     return false;
//   }
//   if (resumeUsedFlag && checkResImgFBUpldImgFlg) {
//     //handling the case where if some 360 images have not being uploaded in resume and imageFeedback then reuploading it.
//     checkResImgFBUpldImgFlg = false;
//     let uploadedImgTagResult = await makeRequest(
//       `/fetchResumeImgFeedbackTag/${inspectionId ? inspectionId : insId}/GET`,
//     );
//     let imageListResult = await makeRequest(
//       `/fetchResumeImgFeedbackImgList/${inspectionId ? inspectionId : insId}`,
//     );
//     let uploadedImgTag = [],
//       imageList = [],
//       uploadingList = [];
//     if (uploadedImgTagResult.ok && uploadedImgTagResult.status === 200) {
//       uploadedImgTag = await uploadedImgTagResult.json();
//     }
//     if (imageListResult.ok && imageListResult.status === 200) {
//       imageList = await imageListResult.json();
//       imageList = imageList["list"];
//     }
//     // console.log(
//     //   "image list at final upload (frontend utils) ::: ++ ",
//     //   imageList,
//     //   uploadedImgTag
//     // );
//     if (uploadedImgTag.length === 0) {
//       //handling the case where no 360 images uploaded
//       let imageTagList = [
//         "Front Capture",
//         "Front Left",
//         "Left Capture",
//         "Back Left",
//         "Back Capture",
//         "Back Right",
//         "Right Capture",
//         "Front Right",
//       ];
//       imageTagList.map((tag) => {
//         let tagImg = imageList.filter((item) => item.currentTag === tag);
//         uploadingList.push(tagImg[0]);
//       });
//     } else {
//       //handling the condition where some images got uploaded
//       uploadedImgTag.map((tag) => {
//         imageList = imageList.filter((item) => item.currentTag !== tag);
//       });
//       uploadingList = imageList;
//     }
//     //upload the images from uplaodingList variable.
//     uploadingList.map((image) => {
//       addImageToList(image);
//     });
//     return false;
//   }
//   if (backupImages.length != 0 && imageSending2 != true) {
//     imageSending2 = true;
//     try {
//       let res;
//       if (iosDevice && getWebpImageFormat()) {
//         const formData = new FormData();
//         let imageBlob;
//         if (Array.isArray(backupImages[0]))
//           imageBlob = backupImages[0][0].imgData;
//         else imageBlob = backupImages[0].imgData;
//         const imageSizeInBytes = imageBlob.size;
//         formData.append("image", imageBlob, "image.jpg");
//         const dataWithoutBlob = { ...backupImages[0] };
//         if (Array.isArray(backupImages[0])) delete dataWithoutBlob[0].imgData;
//         else delete dataWithoutBlob.imgData;
//         let payload = {
//           token,
//           file: dataWithoutBlob,
//           email: userEmail,
//           geolocation: location,
//           count,
//           inspectionId,
//           clientID: clientID,
//           resumeFlag: resumeFlowAllow,
//           storeInRedis: !Array.isArray(backupImages[0]),
//           hiibRedisSingleImageTag: Array.isArray(backupImages?.[0])
//             ? ""
//             : backupImages?.[0]?.tag?.includes(":")
//               ? backupImages[0].tag
//               : backupImages?.[0]?.currentBlockName || "",
//           vmgFlowType,
//           vmgUrl,
//           authorization,
//           hyundaiData,
//           timeStampFlag: resumeTimestampFlag,
//           resumeTimeStampFlagSecond:
//             resumeTimestampFlag &&
//             resumeTimeStamoSecondFlag &&
//             resumeTimeStamoSecondFlagCount,
//           timeStamp: Date.now(),
//           ...(inputMetaDataFlag && { inputMetaData: inputMetaData }),
//           ...(kotakVehicleDataFlag && { kotakVehicleData: kotakVehicleData }),
//         };
//         const dataString = JSON.stringify(payload);
//         const encoder = new TextEncoder();
//         const dataSizeInBytes = encoder.encode(dataString).length;
//         const totalPayloadSizeInBytes = imageSizeInBytes + dataSizeInBytes;
//         const totalPayloadSizeInKB = totalPayloadSizeInBytes / 1024;
//         console.log(
//           `Total payload size in final Upload: ${totalPayloadSizeInKB.toFixed(2)} KB`,
//         );
//         formData.append("data", JSON.stringify(payload));
//         imageSize = totalPayloadSizeInKB.toFixed(2); //extra logs
//         startDateLog = new Date().getTime(); //extra logs
//         endDateLog = 0; //extra logs
//         res = await makeRequest("/imageUploadIosWeb", formData, true);
//       } else {
//         res = await makeRequest("/imageUpload", {
//           token,
//           file: backupImages[0],
//           email: userEmail,
//           geolocation: location,
//           count,
//           inspectionId,
//           vmgFlowType,
//           vmgUrl,
//           authorization,
//           hyundaiData,
//           webpFormat: getWebpImageFormat(),
//           timeStampFlag: resumeTimestampFlag,
//           resumeTimeStampFlagSecond:
//             resumeTimestampFlag &&
//             resumeTimeStamoSecondFlag &&
//             resumeTimeStamoSecondFlagCount,
//           timeStamp: Date.now(),
//           ...(inputMetaDataFlag && { inputMetaData: inputMetaData }),
//           ...(kotakVehicleDataFlag && { kotakVehicleData: kotakVehicleData }),
//         });
//       }
//       if (
//         resumeTimestampFlag &&
//         resumeTimeStamoSecondFlag &&
//         resumeTimeStamoSecondFlagCount
//       )
//         resumeTimeStamoSecondFlagCount = false;
//       if (res.ok) {
//         res.json().then((res1) => {
//           endDateLog = new Date().getTime(); //extra logs
//           if (res1.status === "error") {
//             backupImages.splice(0, 1);
//             imageSending2 = false;
//             let logDetails = {
//               type: "backend",
//               imageName: backupImages[0]["tag"],
//               InternetLatency: getInternetLatency(),
//               message: res1.message || "Unknown backend error",
//               context: res1.context || "finalUpload/backend/imageUploadHandler",
//               stack: res1.stack || "",
//               imageSize: imageSize, //extra logs
//               timeTakenToUpload: endDateLog - startDateLog, //extra logs
//             };
//             pathImageDataHandler(logDetails, inspectionId, "Fail");
//           } else if (res1.status === "success") {
//             backupImages.splice(0, 1);
//             redyForUpload = true;
//             if (Array.isArray(img)) {
//               portoModuleComplete.push(img[0]["tag"]);
//             } else {
//               portoModuleComplete.push(backupImages[0]["tag"]);
//             }
//             // clearInterval(interval)
//             ++count;
//             pathImageDataHandler(
//               `${backupImages[0]["tag"]} uploaded successfully with size ${imageSize} KB with time taken ${endDateLog - startDateLog} ms`,
//               inspectionId,
//               "Success",
//             );
//             if (inputMetaDataFlag) inputMetaDataFlag = false;
//             if (kotakVehicleDataFlag) kotakVehicleDataFlag = false;
//             imageSending2 = false;
//           }
//         });
//       } else {
//         backupImages.splice(0, 1);
//         imageSending2 = false;
//       }
//     } catch (err) {
//       endDateLog = new Date().getTime(); //extra logs
//       backupImages.splice(0, 1);
//       imageSending2 = false;
//       patLogs(err.message, inspectionId);
//       console.log(err.message, err.name);
//       let logDetails = {
//         type: "frontend",
//         message: err.message,
//         InternetLatency: getInternetLatency(),
//         imageName: backupImages[0]["tag"],
//         context: "finalUpload",
//         stack: err.stack || "",
//         imageSize: imageSize, //extra logs
//         timeTakenToUpload: endDateLog - startDateLog, //extra logs
//       };
//       pathImageDataHandler(logDetails, inspectionId, "Fail");
//     }
//   }
//   if (backupImages.length > 0) {
//     return false;
//   }

//   try {
//     if (!imageSending3) {
//       imageSending3 = true;
//       clearInterval(imginterval);
//       const res = await makeRequest("/finalUpload", {
//         count: count,
//         inspectionId,
//         email: userEmail,
//         token,
//         geolocation: location,
//         vmgFlowType,
//         vmgUrl,
//         authorization,
//         customHiibVmg,
//         kotakRecaptureCase,
//         oldInspectionId,
//         clientID: clientID,
//         imageFeedback: imageFeedbackAllow,
//         hyudaiVinDisable,
//       });
//       if (res.ok) {
//         let message = `(Total Images${totalImagesQueue - totalVideos})`;
//         userLogs({ position: 5, fInal_image_upload: "yes", inspectionId });
//         await makeRequest("/setLog", { message, inspectionId });
//         let val = await res.json();
//         if (val.status === "usedToken") {
//           return "usedToken";
//         } else {
//           return true;
//         }
//       }
//       userLogs({ position: 5, fInal_image_upload: "no", inspectionId });
//       imageSending3 = false;
//       return false;
//     }
//   } catch (err) {
//     userLogs({ position: 5, fInal_image_upload: "no", inspectionId });
//     imageSending3 = false;
//     patLogs(err.message, inspectionId);
//     return false;
//   }
// };

export const finalUpload = async (imageFeedbackAllow, resumeUsedFlag) => {
  let startDateLog = 0,
    endDateLog = 0; // extra log
  if (imageQueue.length > 0) {
    return false;
  }
  if (globalImageQueue.length > 0 && imageQueue.length === 0) {
    globalImageQueue.map((image) => {
      addImageToList(image);
    });
    globalImageQueue = [];
    return false;
  }
  if (resumeUsedFlag && checkResImgFBUpldImgFlg) {
    //handling the case where if some 360 images have not being uploaded in resume and imageFeedback then reuploading it.
    checkResImgFBUpldImgFlg = false;
    let uploadedImgTagResult = await makeRequest(
      `/fetchResumeImgFeedbackTag/${inspectionId ? inspectionId : insId}/GET`,
    );
    let imageListResult = await makeRequest(
      `/fetchResumeImgFeedbackImgList/${inspectionId ? inspectionId : insId}`,
    );
    let uploadedImgTag = [],
      imageList = [],
      uploadingList = [];
    if (uploadedImgTagResult.ok && uploadedImgTagResult.status === 200) {
      uploadedImgTag = await uploadedImgTagResult.json();
    }
    if (imageListResult.ok && imageListResult.status === 200) {
      imageList = await imageListResult.json();
      imageList = imageList["list"];
    }
    // console.log(
    //   "image list at final upload (frontend utils) ::: ++ ",
    //   imageList,
    //   uploadedImgTag
    // );
    if (uploadedImgTag.length === 0) {
      //handling the case where no 360 images uploaded
      let imageTagList = [
        "Front Capture",
        "Front Left",
        "Left Capture",
        "Back Left",
        "Back Capture",
        "Back Right",
        "Right Capture",
        "Front Right",
      ];
      imageTagList.map((tag) => {
        let tagImg = imageList.filter((item) => item.currentTag === tag);
        uploadingList.push(tagImg[0]);
      });
    } else {
      //handling the condition where some images got uploaded
      uploadedImgTag.map((tag) => {
        imageList = imageList.filter((item) => item.currentTag !== tag);
      });
      uploadingList = imageList;
    }
    //upload the images from uplaodingList variable.
    uploadingList.map((image) => {
      addImageToList(image);
    });
    return false;
  }
  if (backupImages.length != 0 && imageSending2 != true) {
    imageSending2 = true;

    const currentImage = backupImages[0]; // ✅ FIX: capture safely
    const currentImageTag = Array.isArray(currentImage)
      ? currentImage[0]?.tag
      : currentImage?.tag;

    try {
      let res;

      if (iosDevice && getWebpImageFormat()) {
        const formData = new FormData();

        const imageBlob = Array.isArray(currentImage)
          ? currentImage[0].imgData
          : currentImage.imgData;

        const imageSizeInBytes = imageBlob.size;

        formData.append("image", imageBlob, "image.webp");

        let dataWithoutBlob;

        if (Array.isArray(currentImage)) {
          const [first, second] = currentImage;
          const { imgData, ...firstWithoutBlob } = first;
          dataWithoutBlob = [firstWithoutBlob, second];
        } else {
          dataWithoutBlob = { ...currentImage };
          delete dataWithoutBlob.imgData;
        }

        let payload = {
          token,
          file: dataWithoutBlob,
          email: userEmail,
          geolocation: location,
          count,
          inspectionId,
          clientID,
          resumeFlag: resumeFlowAllow,
          storeInRedis: !Array.isArray(backupImages[0]),
          hiibRedisSingleImageTag: Array.isArray(currentImage)
            ? ""
            : currentImage?.tag?.includes(":")
              ? currentImage.tag
              : currentImage?.currentBlockName || "",
          vmgFlowType,
          vmgUrl,
          authorization,
          hyundaiData,
          timeStampFlag: resumeTimestampFlag,
          resumeTimeStampFlagSecond:
            resumeTimestampFlag &&
            resumeTimeStamoSecondFlag &&
            resumeTimeStamoSecondFlagCount,
          timeStamp: Date.now(),
          ...(inputMetaDataFlag && { inputMetaData: inputMetaData }),
          ...(kotakVehicleDataFlag && { kotakVehicleData: kotakVehicleData }),
        };

        const dataString = JSON.stringify(payload);
        const encoder = new TextEncoder();
        const dataSizeInBytes = encoder.encode(dataString).length;

        const totalPayloadSizeInBytes = imageSizeInBytes + dataSizeInBytes;
        const totalPayloadSizeInKB = totalPayloadSizeInBytes / 1024;

        imageSize = totalPayloadSizeInKB.toFixed(2);

        console.log(`Total payload size in backup image: ${imageSize} KB`);

        formData.append("data", dataString);

        startDateLog = Date.now(); //extra logs

        res = await makeRequest("/imageUploadIosWeb", formData, true);
      } else {
        const payload = {
          token,
          file: currentImage,
          email: userEmail,
          geolocation: location,
          count,
          inspectionId,
          clientID,
          resumeFlag: resumeFlowAllow,
          storeInRedis: !Array.isArray(currentImage),
          hiibRedisSingleImageTag: Array.isArray(currentImage)
            ? ""
            : currentImage?.tag?.includes(":")
              ? currentImage.tag
              : currentImage?.currentBlockName || "",
          vmgFlowType,
          vmgUrl,
          authorization,
          hyundaiData,
          webpFormat: getWebpImageFormat(),
          timeStampFlag: resumeTimestampFlag,
          resumeTimeStampFlagSecond:
            resumeTimestampFlag &&
            resumeTimeStamoSecondFlag &&
            resumeTimeStamoSecondFlagCount,
          timeStamp: Date.now(),
          ...(inputMetaDataFlag && { inputMetaData: inputMetaData }),
          ...(kotakVehicleDataFlag && { kotakVehicleData: kotakVehicleData }),
        };

        const dataString = JSON.stringify(payload);
        const encoder = new TextEncoder();
        const dataSizeInBytes = encoder.encode(dataString).length;

        const totalPayloadSizeInKB = dataSizeInBytes / 1024;
        imageSize = totalPayloadSizeInKB.toFixed(2);

        console.log(`Total payload size in backup image: ${imageSize} KB`);

        startDateLog = Date.now();

        res = await makeRequest("/imageUpload", payload);
      }
      if (
        resumeTimestampFlag &&
        resumeTimeStamoSecondFlag &&
        resumeTimeStamoSecondFlagCount
      ) {
        resumeTimeStamoSecondFlagCount = false;
      }

      if (!res || !res.ok) {
        throw new Error(
          `HTTP error: ${res?.status || "No response From Backend"}`,
        );
      }

      const res1 = await res.json(); // ✅ FIX: proper async

      endDateLog = Date.now();

      if (res1.status === "error") {
        const logDetails = {
          type: "backend",
          imageName: currentImageTag,
          InternetLatency: getInternetLatency(),
          message: res1.message || "Unknown backend error",
          context: res1.context || "imageUpload/backend/imageUploadHandler",
          stack: res1.stack || "",
          imageSize: imageSize ? imageSize : 0,
          timeTakenToUpload: startDateLog ? endDateLog - startDateLog : null,
        };
        pathImageDataHandler(logDetails, inspectionId, "Fail");
        backupImages.shift();
        imageSending2 = false;
        return;
      }

      // ✅ SUCCESS FLOW
      redyForUpload = true;

      let img = currentImage;

      if (Array.isArray(img)) {
        if (portoModuleList.includes(img[0]["tag"])) {
          portoModuleComplete.push(img[0]["tag"]);
        }
      } else {
        if (portoModuleList.includes(img["tag"])) {
          portoModuleComplete.push(img["tag"]);
        }
      }

      pathImageDataHandler(
        `${currentImageTag} uploaded successfully with size ${imageSize ? imageSize : 0} KB with time taken ${endDateLog - startDateLog
        } ms time: ${currentImage?.captureTimestamp}`,
        inspectionId,
        "Success",
      );

      ++count;

      backupImages.shift();
      imageSending2 = false;

      if (inputMetaDataFlag) inputMetaDataFlag = false;
      if (kotakVehicleDataFlag) kotakVehicleDataFlag = false;
      //console.log("Backup image upload successful, moving to next image if any.", currentImage?.captureTimestamp);
    } catch (err) {
      endDateLog = Date.now();

      console.error("UPLOAD ERROR:", err); // ✅ real error

      const logDetails = {
        type: "frontend",
        message: err.message,
        stack: err.stack || "",
        InternetLatency: getInternetLatency(),
        imageName: currentImageTag,
        context: "finalUpload",
        imageSize: imageSize ? imageSize : 0,
        timeTakenToUpload: startDateLog ? endDateLog - startDateLog : null, // ✅ FIX
      };

      patLogs(err.message, inspectionId);
      pathImageDataHandler(logDetails, inspectionId, "Fail");

      backupImages.shift();
      imageSending2 = false;
    }
  }
  if (backupImages.length > 0) {
    return false;
  }

  try {
    if (!imageSending3) {
      imageSending3 = true;
      clearInterval(imginterval);
      const res = await makeRequest("/finalUpload", {
        count: count,
        inspectionId,
        email: userEmail,
        token,
        geolocation: location,
        vmgFlowType,
        vmgUrl,
        authorization,
        customHiibVmg,
        kotakRecaptureCase,
        oldInspectionId,
        clientID: clientID,
        imageFeedback: imageFeedbackAllow,
        hyudaiVinDisable,
      });
      if (res.ok) {
        let message = `(Total Images${totalImagesQueue - totalVideos})`;
        userLogs({ position: 5, fInal_image_upload: "yes", inspectionId });
        await makeRequest("/setLog", { message, inspectionId });
        let val = await res.json();
        if (val.status === "usedToken") {
          return "usedToken";
        } else {
          return true;
        }
      }
      userLogs({ position: 5, fInal_image_upload: "no", inspectionId });
      imageSending3 = false;
      return false;
    }
  } catch (err) {
    userLogs({ position: 5, fInal_image_upload: "no", inspectionId });
    imageSending3 = false;
    patLogs(err.message, inspectionId);
    return false;
  }
};

export const totalImagesUploadStatus = () => {
  return {
    uploadedImage:
      totalImagesQueue -
      (imageQueue.length + backupImages.length + totalVideos),
    totalImage: totalImagesQueue,
  };
};

export const QRDataUpload = async (data) => {
  await makeRequest("/qrData", { inspectionId, data, token });
};

export const formUpload = async (jsonFileWithDocuments, jsonFile, impData) => {
  checkFormupload = setInterval(async () => {
    if (redyForUpload) {
      clearInterval(checkFormupload);
      let data = {
        jsonFileWithDocuments,
        jsonFile,
        impData,
      };

      await makeRequest("/sendForm", { inspectionId, token, data });
    }
  }, 100);
};
export const pdfUpload = async (clientId, inspectionId, data, name) => {
  await makeRequest("/pdfupload", { clientId, inspectionId, data, name });
};
export const signatureUpload = async (clientId, inspectionId, data) => {
  await makeRequest("/signatureUpload", { clientId, inspectionId, data });
};
export const setquestionValue = async (inspectionId, data) => {
  await makeRequest("/questionValue", { inspectionId, data });
};
export const actualRegion = async (data, inspection_id) => {
  await makeRequest("/actualregion", { data, inspection_id });
};

export const vinStatus = async () => {
  try {
    const response = await fetch("/vinstatus");
    const result = await response.json();
    return result;
  } catch (error) {
    console.log(error);
  }
};

export const ping = async () => {
  const res = await fetch("/ping");
  return res.ok;
};

export const lowLightImage = async () => {
  try {
    const response = await fetch("/lowLightImage");
    const result = await response.json();
    return result["status"];
  } catch (error) {
    console.log(error);
  }
};
export const userLogs = async (data, log, flag) => {
  if (setLoggingstatus === "true") {
    try {
      await fetch(process.env.REACT_APP_LAMBDA_LOG_URL, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data),
      });
    } catch (err) {
      console.log("mysql log sending error");
    }
  }

  // try {
  //   if (flag && setLoggingstatus) {
  //     await setUserLogs(log);
  //     userLog = log;
  //     await makeRequest('/saveLogS3', {
  //       inspectionId: log.inspection_id,
  //       data: log
  //     });
  //   }
  //   else if (setLoggingstatus) {
  //     // let res = await makeRequest('/getLogS3', {
  //     //   inspectionId: data.inspectionId
  //     // });

  //     if (data.position === 1) {
  //       userLog["camera_permission"] = data.camera_permission;
  //       userLog["gyro_permission"] = data.gyro_permission;
  //       userLog["location_permission"] = data.location_permission;
  //       userLog["desktop_view"] = data.desktop_view;
  //     }
  //     else if (data.position === 2) {
  //       userLog["image_upload_status"] = data.image_upload_status;
  //     }
  //     else if (data.position === 3) {
  //       userLog["video_data"] = data.video_data;
  //     }
  //     else if (data.position === 5) {
  //       userLog["final_image_Upload"] = data.fInal_image_upload;
  //     }
  //     else if (data.position === 6) {
  //       userLog["model_initialized"] = data.model_initialized;
  //     }
  //     else if (data.position === 7) {
  //       userLog["user_step_covered"] = data.user_step_covered;
  //     }
  //     else if (data.position === 8) {
  //       userLog["last_page"] = data.last_page;
  //     }
  //     else if (data.position === 9) {
  //       userLog["record_button"] = data.record_button;
  //     }
  //     else if (data.position === 12) {
  //       userLog["loading_timer"] = data.loading_timer;
  //     }
  //     else if (data.position === 13) {
  //       userLog["complete_module"] = data.completed_module;
  //     }
  //     //console.log("sending log :: ", userLog)
  //     await makeRequest('/saveLogS3', {
  //       inspectionId: data.inspectionId,
  //       data: userLog
  //     });
  //     // if (res.ok) {
  //     //   let result = await res.json();
  //     //   // console.log("result ::   ", result)
  //     //   let log = result.body;

  //     // }
  //   }
  // }
  // catch (err) {
  //   console.log("error while saving log to s3 ::: ", err);
  // }
};

export const rejectionBatch = async (data) => {
  try {
    const response = await makeRequest("/rejectInspection", data);
    const result = await response.json();
    return result["status"];
  } catch (error) {
    console.log(error);
  }
};

export const addUserAgentData = async (data) => {
  try {
    const response = await makeRequest("/addUserAgentData", data);
    const result = await response.json();
    return result["status"];
  } catch (error) {
    console.log(error);
  }
};

export const gethiibMssg = async (data) => {
  try {
    const response = await makeRequest("/gethiibMssg", data);
    const result = await response.json();
    return result;
  } catch (error) {
    console.log(error);
  }
};

export const vin_detection = async (data) => {
  try {
    const response = await makeRequest("/vinDetection", data);
    const result = await response.json();
    return result.status;
  } catch (error) {
    console.log(error);
    return false;
  }
};

export const imageFeedbackLambda = async (data) => {
  try {
    if (data["resumeFlag"]) {
      setImageFeedbackMsgNImages(
        data["inspection_id"],
        data["imageDate"],
        data["tag"],
      );
      //setImgFeedbackCountResume(true);
    }
    const response = await makeRequest("/imageFeedback", data);
    const result = await response.json();
    if (data["Vin_feedback"]) {
      return result.status;
    } else {
      if (data["tag"] && data["tag"] !== "testing") {
        //("feedback ::: ", result.status);
        totalImageFeedbackMssgResume[data["tag"]] = result.status["feedback"];
        totalImageFeedbackMssg[data["tag"]] = result.status["feedback"];
      }
      return result.status;
    }
  } catch (error) {
    console.log(error);
    return {
      feedback: "",
    };
  }
};

let datas;
let values = "";
const imgStatus = async (inspectionId) => {
  datas = `Images uploading not including final Upload image  ${totalImagesQueue - (imageQueue.length + backupImages.length)
    } / ${totalImagesQueue}`;
  if (values !== datas) {
    values = `Images uploading not including final Upload image  ${totalImagesQueue - (imageQueue.length + backupImages.length)
      } / ${totalImagesQueue}`;
    userLogs({
      position: 2,
      image_upload_status: `${totalImagesQueue - (imageQueue.length + backupImages.length)
        } / ${totalImagesQueue}`,
      inspectionId,
    });
  }
};

export const pathImageDataHandler = (data, inspectionId, status) => {
  const now = new Date();
  const hours = String(now.getHours()).padStart(2, "0");
  const minutes = String(now.getMinutes()).padStart(2, "0");
  const seconds = String(now.getSeconds()).padStart(2, "0");
  const timeString = `${hours}:${minutes}:${seconds}`;
  if (status === "Success") {
    data = `${timeString} - ${data}`;
    userLogs({
      position: 18,
      imageStatus: data,
      inspectionId,
    });
  } else {
    data["timestamp"] = timeString;
    userLogs({
      position: 18,
      imageStatus: JSON.stringify(data),
      inspectionId,
    });
  }
};

export const patLogs = async (data, inspe) => {
  let inspet;
  if (!inspe) inspet = insId;
  else inspet = inspe;
  const now = new Date();
  const hours = String(now.getHours()).padStart(2, "0");
  const minutes = String(now.getMinutes()).padStart(2, "0");
  const seconds = String(now.getSeconds()).padStart(2, "0");
  const timeString = `${hours}:${minutes}:${seconds}`;
  data = `${timeString} - ${data}`;
  pathData.push(data);
  await userLogs({
    position: 7,
    user_step_covered: pathData,
    inspectionId: inspet,
  });
  await makeRequest(`/setUserStepCount/${inspet}/SET`, {
    path: pathData.join(", "),
  });
};

export const mlLogs = async (data) => {
  await patLogs(data, inspectionId);
};

export const setRating = async (data) => {
  try {
    await makeRequest("/setRating", data);
  } catch (err) {
    console.log(err);
  }
};

export const zizoApiCalling = async (sampleImg) => {
  try {
    makeRequest(
      "https://72mxy4glexfyf56zyu6mocbnne0xwmco.lambda-url.eu-central-1.on.aws/",
      {
        inspection_id: "in1234",
        client_id: "sample",
        region: "eu-central-1",
        env: 0,
        image: sampleImg,
        tag: "CAR_ZI",
      },
    );
    makeRequest(
      "https://72mxy4glexfyf56zyu6mocbnne0xwmco.lambda-url.eu-central-1.on.aws/",
      {
        inspection_id: "in1234",
        client_id: "sample",
        region: "eu-central-1",
        env: 0,
        image: sampleImg,
        tag: "CAR_ZI",
      },
    );
    makeRequest(
      "https://72mxy4glexfyf56zyu6mocbnne0xwmco.lambda-url.eu-central-1.on.aws/",
      {
        inspection_id: "in1234",
        client_id: "sample",
        region: "eu-central-1",
        env: 0,
        image: sampleImg,
        tag: "CAR_ZI",
      },
    );
    makeRequest(
      "https://72mxy4glexfyf56zyu6mocbnne0xwmco.lambda-url.eu-central-1.on.aws/",
      {
        inspection_id: "in1234",
        client_id: "sample",
        region: "eu-central-1",
        env: 0,
        image: sampleImg,
        tag: "CAR_ZI",
      },
    );
  } catch (err) {
    console.log("error while calling lambda", err);
  }
};

export const setImgCOunt = async (inspectionId, imgValue) => {
  try {
    await makeRequest("/imgCount", { inspectionId, imgValue });
  } catch (err) {
    console.log(err);
  }
};

export const storeRegionDetection = async (
  currentRegion,
  detectedLabels,
  angle,
) => {
  try {
    await makeRequest(`/feedbackDetectionRegion/${insId}`, {
      currentRegion,
      detectedLabels,
      angle,
    });
  } catch (err) {
    console.log(err);
  }
};

export const vinCheckDB = async (vin) => {
  try {
    let response = await makeRequest("/vinValidation", { vin });
    const result = await response.json();
    return result;
  } catch (err) {
    console.log(err);
    return { status: false, message: "Failed to fetch" };
  }
};

export const imageRedirectFlags = async (inspection_id) => {
  try {
    await makeRequest("/ImageRedirectFlags", { inspection_id });
    return;
  } catch (err) {
    console.log(err);
    return { status: false, message: "Failed to fetch" };
  }
};

export const getLumaBlurScore = async (data) => {
  try {
    let value = makeRequest(
      "https://rbhnak7xwk6krqr6mi55qdcgla0tnoiq.lambda-url.eu-central-1.on.aws/",
      data,
    );
    //console.log(value);
    return value;
  } catch (err) {
    console.log(err);
    return { blur_luma: [1, 5] };
  }
};

export const checkUploadingStatusPorto = () => {
  const data = totalImagesUploadStatus();
  let percentage = Math.floor((data.uploadedImage / data.totalImage) * 100);
  let b = portoModuleList.every((item) => portoModuleComplete.includes(item));
  //console.log("portoModuleList: ", portoModuleList, "percentage :: ", percentage, " portoModuleComplete :: ", portoModuleComplete, " b :: ", b, " allSideCoveredVideo :: ", allSideCoveredVideo);
  if (portoModuleList.includes("360 video")) {
    if (percentage >= 80 && b && allSideCoveredVideo) {
      return true;
    } else {
      return false;
    }
  } else {
    if (percentage >= 80 && b) {
      return true;
    } else {
      return false;
      // return false;
    }
  }
};

const isBridgeAvailable = () => {
  return (
    typeof window !== "undefined" &&
    window.Bridge &&
    typeof window.Bridge.notify === "function"
  );
};

// Optional: mock bridge for development
const mockBridge = (events) => {
  console.info("[MockBridge] Events sent:", JSON.stringify(events, null, 2));
};

export const notifyParentApp = async (events, options = {}) => {
  const { debug = true, throwOnError = false, useMock = true } = options;

  try {
    if (isBridgeAvailable()) {
      window.Bridge.notify(events);

      if (debug) {
        console.log("[Bridge] Notification sent:", events);
      }

      return { success: true };
    }

    // Fallback (browser/dev)
    if (useMock) {
      mockBridge(events);
      return { success: true, mocked: true };
    }

    console.warn("[Bridge] Not available");
    return { success: false, reason: "Bridge not available" };
  } catch (error) {
    console.error("[Bridge] Error:", error);

    if (throwOnError) {
      throw error;
    }

    return { success: false, error };
  }
};

export const createReloadEvent = () => ({
  event: "action",
  property: { reload: true },
});

export const saveDetailsInRedis = async (data) => {
  try {
    await makeRequest("/saveDetailsRedis", data);
  } catch (err) {
    console.log(err);
  }
}

export const storeUserGyroTimespanFlagApi = async (inspectionId, place, time) => {
  try {
    await makeRequest(`/storeUserGyroTimespanFlag/${inspectionId}`, { place, time });
  } catch (err) {
    console.error("Error setting gyro timespan flag:", err);
  }
}


export const createInspectionCompletedEvent = ({
  policyNo,
  uploadCompleted,
}) => ({
  event: "pre_inspection_completed",
  property: {
    policy_no: policyNo,
    upload_completed: uploadCompleted,
  },
});

export const saveInputMetaData = async () => {
  try {
    //console.log("Saving input metadata:", inputMetaData, token);
    await makeRequest("/saveInputMetaData", { inputMetaData: inputMetaData, token });
  } catch (err) {
    console.log("Error while saving input metadata:", err);
  }
}

export const saveClaimReason = async (inspectionId, claimReason) => {
  try {
    //console.log("Saving claim reason:", inspectionId, claimReason);
    await makeRequest("/claimReason", { inspectionId, claimReason });
  } catch (err) {
    console.log("Error while saving claim reason:", err);
  }
}
